import React from 'react'
import { useI18n } from '../../i18n'
import ReadinessRing from './ReadinessRing'
import type { AuditReadinessModel } from './auditReadinessModel'
import { useAuditReadinessSourceLabel } from './useAuditReadiness'
import styles from '../../styles/components/assets/AssetsInformationSystems.module.scss'

interface Props {
  model: AuditReadinessModel
  variant?: 'row' | 'panel'
  onClick?: () => void
  className?: string
}

export default function ReadinessHero({ model, variant = 'row', onClick, className = '' }: Props) {
  const { t } = useI18n()
  const sourceHint = useAuditReadinessSourceLabel(model, t)
  const ringSize = variant === 'panel' ? 'lg' : 'md'
  const heroClass =
    variant === 'panel' ? `${styles.readinessHero} ${styles.readinessHeroPanel}` : styles.readinessHero

  const statusLabel = t(
    `assets.auditReadiness.status.${model.displayStatus}`,
    t(`assets.grc.readiness.${model.operationalStatus}`, model.displayStatus)
  )

  const unknownPosture =
    model.percent == null &&
    model.sourceType === 'NONE' &&
    !['BLOCKED', 'CRITICAL', 'NOT_READY'].includes(model.displayStatus)

  return (
    <ReadinessRing
      size={ringSize}
      percent={model.percent}
      status={model.displayStatus}
      statusLabel={statusLabel}
      blockers={model.blockers}
      blockerSeverity={model.blockerSeverity}
      sourceHint={sourceHint}
      unknownPosture={unknownPosture}
      onClick={onClick}
      className={`${heroClass} ${className}`.trim()}
    />
  )
}
